import { Playground } from '../../../components/playground/Playground';
import { PlaygroundClasses } from '../../../components/playground/PlaygroundClasses';
import { Headline } from '../../../components/Headline';

import { dummyTextShort } from '../../../utils/data';

export const UserSelection = () => (
    <div>
        <Headline anchor='user-select'>User select</Headline>
        <Playground example={userSelectionExample} classes={userSelectionClasses} />
    </div>
);

const userSelectionExample = (
    <div className='display-grid grid-cols-2 grid-cols-1-xs gap-20'>
        <div className='user-select-all'>
            <code className='code-inline-first'>user-select-all</code>
            {dummyTextShort}
        </div>
        <div className='user-select-none'>
            <code className='code-inline-first'>user-select-none</code>
            {dummyTextShort}
        </div>
    </div>
);

const userSelectionClasses = <PlaygroundClasses prefix='user-select-' classes={['all', 'none']} />;
